import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=374495bc&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=374495bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374495bc",
  null
  
)

/* custom blocks */
import block0 from "./Tooltip.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
